import { z } from 'zod';
import { companySchema } from './company-schema';
import { LogoSchema, imageSchema } from './image-schema';
import { metaSchema } from './meta-schema';
import { pageConfigurationSchema } from './page-configuration-schema';
import { subscriptionLevel } from './subscription-level';
import { trustFactorSchema } from './trust-factor-schema';

export type TChain = z.infer<typeof chainSchema>;

export const chainSchema = z.object({
  id: z.number(),
  attributes: z.object({
    name: z.string(),
    leadboxCustomerId: z.string().optional().nullable(),
    showReviewInReceipt: z.boolean(),
    placeId: z.string().optional().nullable(),
    address: z.string().optional().nullable(),
    postarea: z.string().optional().nullable(),
    postcode: z.string().optional().nullable(),
    article: z.string().optional().nullable(),
    email: z.string().optional().nullable(),
    phone: z.string().optional().nullable(),
    website: z.string().optional().nullable(),
    background: imageSchema,
    topImage: imageSchema,
    subscriptionLevel: subscriptionLevel,
    logo: LogoSchema,
    trust_factors: z.object({
      data: z.array(trustFactorSchema),
    }),
    companies: z.object({
      data: z.array(companySchema),
    }),
    configuration: pageConfigurationSchema,
    meta: metaSchema,
  }),
});
